import { Component, Input, Output, EventEmitter, HostListener, Inject } from '@angular/core';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import {
    FormsModule,
    NgForm,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
    FormBuilder,
    FormGroup,
    FormControl,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatIconModule } from '@angular/material/icon';
import { RegisterService } from 'app/services/register.service';
import { NavigationFlowService } from 'app/services/navigation-flow.service';
import { firstValueFrom } from 'rxjs';
import { FerrerCheckboxComponent } from 'app/shared/ferrer-checkbox/ferrer-checkbox.component';
import { DialogUtilsService } from 'app/modules/utils/dialog-utility.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormStateService } from 'app/services/formstate.service';
import { ConsentService } from 'app/services/consent.service';
import { FormArray } from '@angular/forms';
import {EmailVerifyStepComponent} from '../email-verify-window/email_verify_window.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BlockedUserComponent } from '../blocked-user/blocked_user.component';
interface CountryCode {
  value: string;      // The country code (e.g., "ES")
  label: string;      // Full label e.g. "(+34) España"
  prefix: string;     // Just the prefix e.g. "+34"
  name?: string;      // Optional: Just the country name (e.g., "España")
}

@Component({
  selector: 'app-passconsent-missing',
  templateUrl: './pass_consent_missing.component.html',
  styleUrls: ['./pass_consent_missing.component.scss'],
  imports: [
    TranslocoPipe,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule, // Import MatFormFieldModule here
    MatInputModule, // I
    NgSelectModule,
    CommonModule,
    MatProgressSpinnerModule
  ],
})

export class PassConsentMissingComponent {
  @Input() email: string = '';
  @Input() veevaInfo: any;
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();
  @Output() navigate = new EventEmitter<string>();
  anySubConsentChecked = false;
  grupoFerrerLinkHtml = "<a href='https://www.ferrer.com/es/nuestra-actividad/presencia-global' target='_blank' class='text-[#006E75] hover:text-[#003E42] hover:underline cursor-pointer'>Grupo Ferrer</a>";
  registrationForm: FormGroup;
  private resizeListener: (() => void) | null = null;
  showPassword: boolean = false;
  protectionInformation: SafeHtml = '';
  isSubmitting = false;
  constructor(
    private translocoService: TranslocoService,
    private _dialogRef: MatDialogRef<any>,
    private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private registerService: RegisterService,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private dialogUtilsService: DialogUtilsService,
    private formStateService: FormStateService,
    private consentService: ConsentService,
    private navigationFlow: NavigationFlowService
  ) {}
  
  termsContent: string = '';
  userPrivacyContent: string = '';
  registerApiError: string = '';
  isOpen: boolean = false;
  countrySearchTerm: string = '';
  filteredCountries: any[] = [];
  mainConsent: boolean = false;
  subConsent1: boolean = false;
  subConsent2: boolean = false;
  disableMain: boolean = false;
  disableSubs: boolean = false;
  dialCodeSearchTerm: string = '';
  private allSubConsents: any[] = [];
  userConsent = [];
  filteredDialCodes: any[] = [];
  subConsents: { contentType: string; checked: boolean; content: string }[] = [];
  countryCodes : CountryCode[] = [
    { value: '52', label: '(+52) México', prefix: '+52' },
    { value: '34', label: '(+34) España', prefix: '+34' },  
  ];
  selectedCountryCode : CountryCode = this.countryCodes[0]; 
  ngOnInit(): void {
    try {
      // This will throw error if cross-origin
      origin = window.parent.origin;
    } catch (e) {
      // If can't access parent origin directly, use referrer
      origin = document.referrer ? new URL(document.referrer).origin : null;
    }
    this.userConsent = this.veevaInfo.econsents || [];
    this.createForm();
    this.loadconsentsCache();
    this.loadtermsPrivacyCache();
    this.loadcountriesProfessionCache();
    this.loadCountryCodes();
    
    this.restoreSavedFormState();
    //this.loadveevainfo();
  }

  changeLang(lang: string) {
    this.translocoService.setActiveLang(lang);
  }
  createForm(): void {
    this.registrationForm = this.fb.group({
 
      password: ['', [
        Validators.required, 
        Validators.minLength(6),
        Validators.maxLength(16),
        PassConsentMissingComponent.noWhitespaceValidator
      ]],
      mainConsent: [false],
      termsConsent: [false, [Validators.requiredTrue]],
      dataConsent: [false],
      subConsents: this.fb.array([])
    });

  }
  
  get subConsentsFormArray(): FormArray {
    return this.registrationForm.get('subConsents') as FormArray;
  }
  
  // Call this when loading consents
  setupSubConsentControls(consents: any[], savedState: any[] = []): void {
    // Clear existing controls
    while (this.subConsentsFormArray.length) {
      this.subConsentsFormArray.removeAt(0);
    }
    
    // Add new controls for each consent
    consents.forEach(consent => {
      const matchingSavedConsent = savedState.find(sc => sc.contentType === consent.id);
      this.subConsentsFormArray.push(this.fb.group({
        contentType: [consent.id],
        checked: [matchingSavedConsent ? matchingSavedConsent.checked : false],
        content: [consent.detailedDescription]
      }));
    });
  }
  
  closeDialog(): void {
    this.dialogUtilsService.closeDialog(this._dialogRef);
  }

  goToTermsStep():void {
    this.formStateService.saveRegistrationFormState({
      formValues: this.registrationForm.value,
      countrySearchTerm: this.countrySearchTerm,
      dialCodeSearchTerm: this.dialCodeSearchTerm,
      selectedCountryCode: this.selectedCountryCode
    });
    
    this.navigate.emit('terms');
  
  }
  gotoUserPrivacyStep():void {
    this.formStateService.saveRegistrationFormState({
      formValues: this.registrationForm.value,
      countrySearchTerm: this.countrySearchTerm,
      selectedCountryCode: this.selectedCountryCode
    });
    
    this.navigate.emit('privacy');
  
  }

 
  async openRegisterDialog(): Promise<void> {
    // Use NavigationFlowService to open login dialog
    await firstValueFrom(this.navigationFlow.openLoginDialog());
  }


  openEmailVerifiedDialog(): void {
    if (this._dialogRef) {
      // Close without animation
      this._dialogRef.close();
    }

    const { width, height } = this.dialogUtilsService.calculateDialogSize();

    this._dialogRef = this._dialog.open(EmailVerifyStepComponent, {
      width: `${width}px`,
      //height: `${height}px`,
      maxWidth: '90vw',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      // Disable enter animation
      enterAnimationDuration: '0ms',
      // Disable exit animation
      exitAnimationDuration: '0ms',
      data:{
        email:this.email
      }
    });

    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this._dialogRef);

    this._dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this._dialogRef = null;
    });
  }
  onSubmit(): void {
    if (this.registrationForm.invalid) {
      // Mark all fields as touched to trigger validation messages
      Object.keys(this.registrationForm.controls).forEach(key => {
        const control = this.registrationForm.get(key);
        control?.markAsTouched();
      });
      this.registerApiError = this.translocoService.translate('errors.registerFormMissing');
      return;
    }
    this.isSubmitting = true;
    
    const allConsents = this.combineAllConsents();
    const formData = {
      ...this.registrationForm.value,
      email: this.email,
      econsents:allConsents
    };
    formData.telephone = this.veevaInfo.telephone || '';
    formData.firstName = this.veevaInfo.firstName || '';
    formData.lastName = this.veevaInfo.name || '';
    formData.confirmEmail = this.email;
    formData.postalCode = this.veevaInfo.postalCode;
    formData.city = this.veevaInfo.city || '';
    formData.country = this.veevaInfo.country;
    formData.language = this.veevaInfo.language;
    formData.gender = this.veevaInfo.gender;
    formData.profession = this.veevaInfo.prefession || 'OTHERPS';
    formData.isVeeva = true;
    if (this.veevaInfo.listAddress && Array.isArray(this.veevaInfo.listAddress) && this.veevaInfo.listAddress.length > 0) {
          // First try to find primary address
          let addressWithPhone = this.veevaInfo.listAddress.find(addr => addr.primary && addr.phone);
          
          // If no primary address with phone, take any address with a phone
          if (!addressWithPhone) {
            addressWithPhone = this.veevaInfo.listAddress.find(addr => addr.phone);
          }
          
          // If we found an address with phone, process it
          if (addressWithPhone && addressWithPhone.phone) {
            formData.phoneNumber = addressWithPhone.phone;
          }
          if (!formData.phoneNumber) {
            formData.phoneNumber = this.veevaInfo.cellPhone || this.veevaInfo.professionalPhone;
          }
    }
    this.registerService.sendRegisterData(formData)
        .subscribe({
          next: (response) => {
            this.isSubmitting = false;
            if(response){
              // variara segun el contenido
              this.openEmailVerifiedDialog();
            }else{
              this.isSubmitting = false;
              this.handleApiError(response);
              this.openEmailVerifiedDialog();
            }
          },
          error: (err) => {
            this.isSubmitting = false;
            this.handleApiError(err);
          }
        });
  }



  // Add this method to toggle password visibility
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  loadconsentsCache() {
    const cachedConsent = localStorage.getItem('ferrer_consentcache');
    const cachedTimestamp = localStorage.getItem('ferrer_consentcache_timestamp');

    const now = new Date().getTime();
    const expirationTime = 24 * 60 * 60 * 1000;
      this.consentService.getConsent(this.getCurrentUserCountry()).subscribe((consentContent) => {
        if (consentContent != undefined){
          localStorage.setItem('ferrer_consentcache_timestamp', now.toString());
          localStorage.setItem('ferrer_consentcache', JSON.stringify(consentContent));
        }
        this.allSubConsents = consentContent.consents.map((item: any) => ({
          contentType: item.id,
          checked: false,
          content: item.detailedDescription
        }));
        
        this.subConsents = this.allSubConsents.map(consent => ({...consent}));
        this.filterUnacceptedConsents();
        this.initializeConsentState(); 
      });
      this.consentService.getTermsNPrivacy(this.getCurrentCountry()).subscribe((consentContent) => {
        localStorage.setItem('ferrer_termprivacycache', JSON.stringify(consentContent));
        this.protectionInformation = this.sanitizer.bypassSecurityTrustHtml(consentContent.disclaimer);
        this.updateDataConsentValidation();
      });
      
        
    // }
  }

  updateDataConsentValidation(): void {
    const dataConsentControl = this.registrationForm.get('dataConsent');
    if (this.showDataConsentField()) {
      // If the field is visible, it must be checked (requiredTrue)
      dataConsentControl?.setValidators([Validators.requiredTrue]);
    } else {
      // If it's not visible, it has no validators
      dataConsentControl?.clearValidators();
    }
    // Apply the new validation rules
    dataConsentControl?.updateValueAndValidity();
  }
  loadtermsPrivacyCache(){
    const cachedTerms = localStorage.getItem('ferrer_terms');
    const cachedPrivacy = localStorage.getItem('ferrer_user_privacy');
    const cachedTimestamp = localStorage.getItem('ferrer_terms_timestamp');

    const now = new Date().getTime();
    //const expirationTime = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
    const expirationTime = 20000;
    if (cachedTerms && cachedTimestamp && now - parseInt(cachedTimestamp, 10) < expirationTime) {
      this.termsContent = cachedTerms;
      this.userPrivacyContent = cachedPrivacy;
    } else {
      this.consentService.getTermsNPrivacy(this.getCurrentSessionCountry()).subscribe((termsContent) => {
        this.termsContent = termsContent.terms;
        
        localStorage.setItem('ferrer_terms', termsContent.terms);
        localStorage.setItem('ferrer_terms_timestamp', now.toString());
        localStorage.setItem('ferrer_user_privacy', termsContent.privacy);
        localStorage.setItem('ferrer_terms_timestamp', now.toString());
      });
    }
  }

  loadcountriesProfessionCache(){
    const cachedProfessionals = localStorage.getItem('ferrer_professionals');
    const cachedCountries = localStorage.getItem('ferrer_countries');
    const cachedTimestamp = localStorage.getItem('ferrer_terms_timestamp');

    const now = new Date().getTime();
    const expirationTime = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
    
  }
shouldShowCloseButton(): boolean {
    const apiVersion = JSON.parse(localStorage.getItem('ferrerSessionData'));
    return this.dialogUtilsService.shouldShowCloseButton();
}
loadCountryCodes(): void {
  const cachedPhonePrefixes = localStorage.getItem('ferrer_phone_prefixes');
  const cachedTimestamp = localStorage.getItem('ferrer_terms_timestamp');

  const now = new Date().getTime();
  const expirationTime = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

  if (cachedPhonePrefixes && cachedTimestamp && now - parseInt(cachedTimestamp, 10) < expirationTime) {
    this.countryCodes = JSON.parse(cachedPhonePrefixes);
    this.selectedCountryCode = this.countryCodes.find(code => this.getCountryDefaultLabelBylanguge(this.translocoService.getActiveLang().toUpperCase())) || this.countryCodes[0];
  } else {
    this.registerService.getphonePrefix().subscribe({
      next: (phonePrefixes) => {
        this.countryCodes = phonePrefixes;
        
        this.selectedCountryCode = this.countryCodes.find(code => this.getCountryDefaultLabelBylanguge(this.translocoService.getActiveLang().toUpperCase()) ) || this.countryCodes[0];
        // Cache the data
        localStorage.setItem('ferrer_phone_prefixes', JSON.stringify(phonePrefixes));
        localStorage.setItem('ferrer_terms_timestamp', now.toString());
      },
      error: (error) => {
      }
    });
  }
}
handleApiError(error: any): void {
  
  // Default error message
  let errorMessage = 'An unexpected error occurred';
  
  // Get error response body
  const errorBody = error.error.message || error.error || error;
  this.registerApiError = errorBody;

  if(errorBody.includes('Prohibido el acceso') ){
      this.openBlockedDialog();
      return;
  }
  // Check for specific error types and map to form fields
  if (errorBody.code === 'AUTH_INVALID_CREDENTIALS' || errorBody.includes('No hay ning')) {
      // Invalid credentials - could be either email or password
      //this.emailApiError = errorBody;
  } else if (errorBody.code === 'AUTH_USER_NOT_FOUND' || errorBody.includes('user not found')) {
      // User not found - email issue
      //this.emailApiError = 'User not found';
  } else if (errorBody.code === 'AUTH_ACCOUNT_LOCKED' || errorBody.includes('locked')) {
      // Account locked
      //this.emailApiError = 'Account is locked. Please contact support.';
  } else if (errorBody.fieldErrors) {
      // Field-specific errors from API
      errorBody.fieldErrors.forEach(fieldError => {
          if (fieldError.field === 'email') {
          //    this.emailApiError = fieldError.message;
          } else if (fieldError.field === 'password') {
           //   this.passwordApiError = fieldError.message;
          }
      });
  } else {
      // Generic error - show in both fields or use a general alert
      //this.emailApiError = errorMessage;
  }
}

restoreSavedFormState(): void {
  const savedState = this.formStateService.getRegistrationFormState();
  
  if (savedState) {
    // Restore form values
    this.registrationForm.patchValue(savedState.formValues);
    
    // Restore dropdown state
    this.countrySearchTerm = savedState.countrySearchTerm || '';
    
    this.dialCodeSearchTerm = savedState.dialCodeSearchTerm || '';
    // Restore phone code
    if (savedState.selectedCountryCode) {
      this.selectedCountryCode = savedState.selectedCountryCode;
    }
    
    // Re-run any necessary filtering
    
    if (savedState) {
    // After patching values, initialize consent state
    setTimeout(() => this.initializeConsentState(), 0);
    }
    
  }
}
onMainConsentChange(): void {
  // Use form value consistently instead of class property
  const mainConsentValue = this.registrationForm.get('mainConsent').value;
  
  if (mainConsentValue) {
    // Check all sub-consents in the FormArray
    this.subConsentsFormArray.controls.forEach(control => {
      control.get('checked').setValue(true);
    });
    this.disableSubs = true;
    this.disableMain = false;
  } else {
    // Uncheck all subconsents when main is unchecked
    this.subConsentsFormArray.controls.forEach(control => {
      control.get('checked').setValue(false);
    });
    this.disableSubs = false;
  }
}

openBlockedDialog(): void {
        // Close any existing dialog
    if (this._dialogRef) {
      this._dialogRef.close();
    }

    const { width, height } = this.dialogUtilsService.calculateDialogSize();

    this._dialogRef = this._dialog.open(BlockedUserComponent, {
      width: `${width}px`,
      //height: `${height}px`,
      maxWidth: '90vw',
      maxHeight: '65vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      data : {
        loginaction: "passwordLogin"
      }
    });

    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this._dialogRef);

    this._dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this._dialogRef = null;
    });
}
onSubConsentChange(): void {
  // Check if any subConsent is checked
  this.anySubConsentChecked = this.subConsentsFormArray.controls.some(
    control => control.get('checked')?.value === true
  );

  if (this.anySubConsentChecked) {
    this.registrationForm.get('mainConsent')?.setValue(false);
    this.disableMain = true;
    this.disableSubs = false;
  } else {
    this.disableMain = false;
  }
}
getCurrentCountry(): string {
  const session = JSON.parse(localStorage.getItem('ferrerSessionData'));
  if (session) {
    return session.country;
  }
    return '';
}

getCurrentUserCountry(): string {
  if (this.veevaInfo.country) {
    return this.veevaInfo.country;
  }
    return '';
}

getCurrentSessionCountry(): string {
  const session = JSON.parse(localStorage.getItem('ferrerSessionData'));
  if (session) {
    return session.country;
  }
    return '';
}

combineAllConsents(): Record<string, boolean> {
  // Create result object to hold all consents
  const combinedConsents: Record<string, boolean> = {};
  
  const validConsentIds = new Set(this.allSubConsents.map(consent => consent.contentType));
  
  // Process all consents, with default value of false
  this.allSubConsents.forEach(consent => {
    combinedConsents[consent.contentType] = false;
  });
  
  // Mark consents that are already accepted in userConsent as true
  if (Array.isArray(this.userConsent)) {
    this.userConsent.forEach(consentId => {
      if (validConsentIds.has(consentId)) {
        combinedConsents[consentId] = true;
      }
    });
  }
  
  // Update with user selections from the displayed subconsents form
  this.subConsentsFormArray.controls.forEach(control => {
    const contentType = control.get('contentType')?.value;
    const checked = control.get('checked')?.value;
    
    if (contentType) {
      combinedConsents[contentType] = checked;
    }
  });
  
  console.log('Combined consents:', combinedConsents);
  return combinedConsents;
}
initializeConsentState(): void {
  // Check if main consent is selected
  const mainConsentChecked = this.registrationForm.get('mainConsent')?.value;
  
  // Check if any subconsent is checked
  this.anySubConsentChecked = this.subConsentsFormArray.controls.some(
    control => control.get('checked')?.value === true
  );
  
  // Set up proper disabled states
  if (mainConsentChecked) {
    this.disableSubs = true;
    this.disableMain = false;
  } else if (this.anySubConsentChecked) {
    this.disableMain = true;
    this.disableSubs = false;
  }
}

  getCountryDefaultLabelBylanguge(lang: string): string {
      if (lang === 'LAT'){
        return 'MX';
      }else if (lang === 'EN'){
        return 'GB';
      } else {
        return 'ES';
      }
  }

  static noWhitespaceValidator(control: FormControl): {[key: string]: boolean} | null {
      // Check if the input string has any spaces
      const containsSpaces = (control.value || '').includes(' ');
      return containsSpaces ? { 'containsSpaces': true } : null;
  }

   showDataConsentField(): boolean {
    try {
      const termPrivacyCache = localStorage.getItem('ferrer_termprivacycache');
      if (!termPrivacyCache) return false;
      
      const isHca = JSON.parse(termPrivacyCache).isHca;
      return isHca === true;
    } catch (e) {
      return false; // If parsing fails, default to not showing.
    }
  }

updateConsentSpecialDataProcessingValidation(): void {
    const ConsentSpecialDataProcessing = this.registrationForm.get('ConsentSpecialDataProcessing');
    if (this.showSpecialDataProcessingField()) {
      // If the field is visible, it must be checked (requiredTrue)
      ConsentSpecialDataProcessing?.setValidators([Validators.requiredTrue]);
    } else {
      // If it's not visible, it has no validators
      ConsentSpecialDataProcessing?.clearValidators();
    }
    // Apply the new validation rules
    ConsentSpecialDataProcessing?.updateValueAndValidity();
  }

  showSpecialDataProcessingField() : boolean{
   
    const selectedCountry = this.veevaInfo.country;

    
    const sessionCountry = this.getCurrentSessionCountry();

    if (!selectedCountry || !sessionCountry) {
      return false;
    }

    return selectedCountry !== sessionCountry;
  }

 


  

  filterUnacceptedConsents(): void {
    // First check if userConsent exists and has data
    if (!this.userConsent) {
      // If no user consents available, keep all subconsents
      console.log("entering wrong function");
      return;
    }
    console.log("estas llegando", this.userConsent);
    console.log(this.subConsents);
    this.subConsents = this.subConsents.filter(subConsent => {
     return !this.userConsent.includes(subConsent.contentType);
    });
    console.log("filtered subconsents", this.subConsents);
    const savedState = this.formStateService.getRegistrationFormState();
    const savedSubConsents = savedState?.formValues?.subConsents || [];

    this.setupSubConsentControls(
      this.subConsents.map(consent => ({ 
        id: consent.contentType,
        detailedDescription: consent.content
      })),
      savedSubConsents
    );
    
  }

  loadveevainfo(): void{
    this.registerService.checkUserVeevaInfo(this.email).subscribe({
      next: (veevaInfo) => {
        if (veevaInfo && Object.keys(veevaInfo).length > 0) {
        // Pre-populate form with Veeva data
        const formUpdates: any = {
          firstName: veevaInfo.firstName || '',
          lastName: veevaInfo.name || '',  
          profession: veevaInfo.profession || '',
          country: veevaInfo.country || '',
          postalCode: veevaInfo.postalCode || ''
        };

        if (veevaInfo.listAddress && Array.isArray(veevaInfo.listAddress) && veevaInfo.listAddress.length > 0) {
          // First try to find primary address
          let addressWithPhone = veevaInfo.listAddress.find(addr => addr.primary && addr.phone);
          
          // If no primary address with phone, take any address with a phone
          if (!addressWithPhone) {
            addressWithPhone = veevaInfo.listAddress.find(addr => addr.phone);
          }
          
          // If we found an address with phone, process it
          if (addressWithPhone && addressWithPhone.phone) {
            const phoneNumber = addressWithPhone.phone;
            
            // Try to extract country code and base number
            try {
              // Handle phone formats like +559636321093
              const matchResult = phoneNumber.match(/^\+(\d+)(\d+)$/);
              
              if (matchResult && matchResult.length === 3) {
                const [_, countryCode, baseNumber] = matchResult;
                
                // Find the matching country code in the dropdown
                const matchingCode = this.countryCodes.find(
                  code => code.value === countryCode || code.prefix === `+${countryCode}`
                );
                
                if (matchingCode) {
                  this.selectedCountryCode = matchingCode;
                  this.dialCodeSearchTerm = matchingCode.prefix;
                  formUpdates.telephone = baseNumber;
                } else {
                  // If we can't find a matching country code, just use the full number
                  formUpdates.telephone = phoneNumber.replace(/\D/g, '');
                }
              } else {
                // If format doesn't match expected pattern, use as is
                formUpdates.telephone = phoneNumber.replace(/\D/g, '');
              }
            } catch (e) {
              console.warn('Error parsing phone number from Veeva data', e);
              formUpdates.telephone = phoneNumber.replace(/\D/g, '');
            }
          }
          
          // If no postalCode was found directly, try to get it from the address
          if (!formUpdates.postalCode && addressWithPhone && addressWithPhone.provinceZip) {
            formUpdates.postalCode = addressWithPhone.provinceZip;
          }
          
          // If no city was found directly, try to get it from the address
          if (!formUpdates.city && addressWithPhone && addressWithPhone.city) {
            formUpdates.city = addressWithPhone.city;
          }
        }
        
        // Try alternate phone fields if no phone found yet
        if (!formUpdates.telephone) {
          const phoneNumber = veevaInfo.cellPhone || veevaInfo.professionalPhone;
          if (phoneNumber) {
            // Use the existing phone parsing logic
            try {
              const matchResult = phoneNumber.match(/^\+(\d+)(\d{9,})$/);
              
              if (matchResult && matchResult.length === 3) {
                const [_, countryCode, baseNumber] = matchResult;
                
                const matchingCode = this.countryCodes.find(
                  code => code.value === countryCode || code.prefix === `+${countryCode}`
                );
                
                if (matchingCode) {
                  this.selectedCountryCode = matchingCode;
                  this.dialCodeSearchTerm = matchingCode.prefix;
                  formUpdates.telephone = baseNumber;
                } else {
                  formUpdates.telephone = phoneNumber.replace(/\D/g, '');
                }
              } else {
                formUpdates.telephone = phoneNumber.replace(/\D/g, '');
              }
            } catch (e) {
              formUpdates.telephone = phoneNumber.replace(/\D/g, '');
            }
          }
        }
        // Handle cedula/UCI if available (could be in oneKeyCode or userSpecialty)
        if (veevaInfo.oneKeyCode) {
          formUpdates.cedula = veevaInfo.oneKeyCode;
        }

        // Update the form with the Veeva data
        this.registrationForm.patchValue(formUpdates);
        
      }
    },
    error: (error) => {
      console.error('Error loading Veeva info:', error);
    }
  });
  }
}